export const isNullOrUndefined = value => {
  return value === null || value === undefined;
};
export const isNullUndefinedOrEmpty = value => {
  if (isNullOrUndefined(value)) return true;
  return value && Object.keys(value).length === 0;
};
export const isLocalEvaluationMode = flag => {
  var _flag$metadata;

  return (flag === null || flag === void 0 ? void 0 : (_flag$metadata = flag.metadata) === null || _flag$metadata === void 0 ? void 0 : _flag$metadata.evaluationMode) === 'local';
};
export const isRemoteEvaluationMode = flag => {
  var _flag$metadata2;

  return (flag === null || flag === void 0 ? void 0 : (_flag$metadata2 = flag.metadata) === null || _flag$metadata2 === void 0 ? void 0 : _flag$metadata2.evaluationMode) === 'remote';
};
//# sourceMappingURL=index.js.map